module.exports = __webpack_public_path__ + "img/icon-03.d0ae8b29.svg";